import { r as i, h as e, H as n } from "./main-bb89b2f2.js";
import "vue";
const o = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block}.title{font-size:12px;-webkit-hyphens:auto;hyphens:auto;line-height:14px;overflow-wrap:anywhere;word-break:normal}.static{position:static}.m-0{margin:var(--spacing-0)}.flex{display:flex}.h-\\[28px\\]{height:28px}.h-\\[32px\\]{height:32px}.min-h-\\[76px\\]{min-height:76px}.w-full{width:100%}.flex-col{flex-direction:column}.justify-center{justify-content:center}.bg-gray-50{background-color:var(--color-neutral-steel-50)}.p-0{padding:var(--spacing-0)}.py-2{padding-bottom:var(--spacing-2);padding-top:var(--spacing-2)}.px-4{padding-left:var(--spacing-4);padding-right:var(--spacing-4)}.font-head{font-family:var(--headline-font-family)}.text-gray-700{color:var(--color-neutral-steel-700)}", d = o, l = class {
  constructor(t) {
    i(this, t), this.cardTitle = "";
  }
  render() {
    const t = {
      "w-full min-h-[76px] py-2 px-4 bg-gray-50": !0
      // 76: 2*8 padding + 28 title + 32 content
    }, a = {
      title: !0,
      "h-[28px] p-0 m-0": !0,
      "text-gray-700 font-head": !0
    }, r = {
      content: !0,
      "h-[32px]": !0,
      "flex flex-col justify-center": !0
    };
    return e(n, { key: "1860c1a7977e7aa04733de6bd5dd07e8e1e8d9a7" }, e("div", { key: "cd96bbbabdfacde57743eaed9def2d150dd20327", class: t }, e("div", { key: "64925620971e062b4bdaeff4ec667ad965b341fd", class: a }, this.cardTitle), e("div", { key: "1e4f3447aa34f80b88ea2b9ac2b848bcc78c5521", class: r }, e("slot", { key: "aa98a41ae5bc1973f410dbabd6e5562d4b6a647c" }))));
  }
};
l.style = d;
export {
  l as patternlib_dashboard_card_contentcard
};
